import { plural } from '@kominiarz/shared';
import { useMutation } from '@tanstack/react-query';
import { errorMessage } from '../../lib/api';
import { disablePush, enablePush, PUSH_KEY, removePushDevice, sendTestPush } from '../../lib/push';
import { queryClient } from '../../lib/queryClient';
import { useToast } from '../Toast';

const refresh = () => queryClient.invalidateQueries({ queryKey: PUSH_KEY });

/** Turning notifications on/off on this device, the test notification, removing devices. */
export function usePushActions() {
  const toast = useToast();

  const enable = useMutation({
    mutationFn: (publicKey: string) => enablePush(publicKey),
    onSuccess: (permission) => {
      if (permission === 'granted') toast.success('Powiadomienia włączone');
      else if (permission === 'denied') toast.error('Nie zezwolono na powiadomienia. Można to zmienić w ustawieniach przeglądarki.');
    },
    onError: (err) => toast.error(errorMessage(err) || 'Nie udało się włączyć powiadomień.'),
    onSettled: refresh,
  });

  const disable = useMutation({
    mutationFn: disablePush,
    onSuccess: () => toast.success('Powiadomienia wyłączone na tym urządzeniu'),
    onError: (err) => toast.error(errorMessage(err)),
    onSettled: refresh,
  });

  const test = useMutation({
    mutationFn: sendTestPush,
    onSuccess: (r) => {
      if (r.delivered > 0) {
        toast.success(`Wysłano na ${plural(r.delivered, 'urządzenie', 'urządzenia', 'urządzeń')}. Powiadomienie pojawi się za chwilę.`);
      } else if (r.devices === 0 || r.devices === r.removed) {
        toast.error('Żadne urządzenie nie ma włączonych powiadomień. Włącz je ponownie.');
      } else {
        toast.error('Nie udało się wysłać powiadomienia. Spróbuj za chwilę.');
      }
    },
    onError: (err) => toast.error(errorMessage(err)),
    onSettled: refresh,
  });

  const remove = useMutation({
    mutationFn: removePushDevice,
    onSuccess: () => toast.success('Usunięto urządzenie'),
    onError: (err) => toast.error(errorMessage(err)),
    onSettled: refresh,
  });

  return { enable, disable, test, remove };
}
